export default __webpack_public_path__ + "static/media/Resume.067bc2bb.jpg";